import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { actionGetApiDataKey } from '../../../actions/apiData/index';

import * as c from '../../../common/_constants';
import * as t from '../../../common/_titles';

import Sections from './Sections';
import Loading from '../../common/Loading';

class Main extends Component {

	componentDidUpdate(){

		document.title = t.TITLE_RESOURCES_PODCASTS;

		if (this.props.podcasts && !this.props.podcasts.error && !this.props.podcasts.loading){
			const params = queryString.parse(this.props.location.search);
			this.props.dispatch(actionGetApiDataKey(c.API_DATA.resources_podcasts.key, params));
		}
	}
	
	componentDidMount() {

		const params = queryString.parse(this.props.location.search);
		this.props.dispatch(actionGetApiDataKey(c.API_DATA.resources_podcasts.key, params));

	}
	render() {
		const {
			podcasts
		} = this.props;
		return (
			<div id="content-resources-podcasts">
				<div className="row">
					<div className="col-md-12">
						<h1>My Podcasts</h1>
					</div>
				</div>
				{podcasts
					? podcasts.error
						? <div><p>Sorry, an error occurred</p></div>
						: podcasts.loading
							? <Loading />
							: <Sections data={podcasts.data.content} />
					: <Loading />
				}
				
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		podcasts: state.apiData.resources_podcasts,
	}
}

export default connect(mapStateToProps)(Main);
